export const MAIN_NAV = [
  { href: "/", label: "Dashboard" },
  { href: "/explore/roi", label: "ROI" },
  { href: "/liquidity", label: "Liquidity" },
  { href: "/explore/shares", label: "Shares" },
  { href: "/explore/adoption", label: "Adoption" },
  { href: "/explore/inflation", label: "Inflation" },
  { href: "/explore/heartbeat", label: "Heartbeat" },
  // { href: "/explore/social", label: "Social" },
] as const;
